// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"da3f3e4d","508":"99c0a8cd","525":"d4493986","560":"98588cca","561":"6d8241ce","670":"fd9425da","929":"3ee56cfd"}[chunkId] + ".chunk.js";
};